module.exports = __webpack_public_path__ + "static/media/classic2.bee0117b.jpg";